var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdentification = function SvgIdentification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.33 17.5H1.664V5H18.33zM6.665 11.667a2.5 2.5 0 0 0-2.5 2.5V15h6.666v-.833a2.5 2.5 0 0 0-2.5-2.5zm6.666 0v1.666h2.5v-1.666zM7.498 7.5a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334m4.167 2.5h4.166V8.333h-4.166zm6.665-5.833H1.664V2.5H18.33z"
  })));
};
export default SvgIdentification;